import { memo, useMemo, useCallback } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import PopupBase from "./popupBase";
import ActionBtn from "../ActionBtn";

const Popup = ({ recordID, onApply, name, large = true, resetAllFields, children, modalID, AdditionalTitle, btnName, title }) => {
    const { t } = useTranslation();

    const handleClose = useCallback(() => {
        resetAllFields?.();
    }, [recordID, resetAllFields]);

    const displayTitle = useMemo(() => {
        return title || (t(`${name} ${recordID ? recordID : ""}`) + `${AdditionalTitle ? AdditionalTitle : ""}`);
    }, [title, name, AdditionalTitle, t]);

    return (
        <>
            <div className="add-new-pation">
                <button ref={modalID} data-toggle="modal" data-target={`#${name}`} hidden></button>
                <PopupBase
                    name={name}
                    large={large}
                    title={displayTitle}
                    onClose={handleClose}
                >
                    <div className="row">
                        {children}
                    </div>
                    <ActionBtn onApply={onApply} title={btnName || "Save"} />
                </  PopupBase>
            </div>
        </>
    );
};

export default memo(Popup);
